import React, { memo } from "react";

import { Cell } from "./acosCell";
import StatusText from "../../typography/status";

export const getStatusFromTACOS = (
  tacos: number | "-",
  conditionalFormatting?: boolean
) =>
  conditionalFormatting === false
    ? "disabled"
    : tacos
    ? tacos === "-"
      ? "disabled"
      : tacos <= 10
      ? "success"
      : tacos <= 15
      ? "warning"
      : "error"
    : "disabled";

interface TACOSCellCellProps {
  row: { original: { tacos: number | "-" } };
  cell: {
    value: {
      raw: number;
      value: number;
      conditionalFormatting?: boolean;
    };
  };
}

const TACOSCell = memo<TACOSCellCellProps>(function TACOSCell({ cell, row }) {
  const { value } = cell.value;
  const conditionalFormatting = cell.value.conditionalFormatting;
  const tacos = row.original.tacos;
  const status = getStatusFromTACOS(tacos, conditionalFormatting);

  return (
    <Cell>
      <StatusText justify="flex-end" variant="body2" status={status}>
        {value}
      </StatusText>
    </Cell>
  );
});

export default TACOSCell;
